.actividad { display: flex; flex-direction: column; gap: var(--s-7); }
.dia { display: flex; flex-direction: column; gap: var(--s-5); }
.fecha {
  font-family: var(--font-body);
  font-size: var(--fs-3xs);
  font-weight: var(--fw-semibold);
  letter-spacing: var(--ls-eyebrow);
  text-transform: uppercase;
  color: var(--text-muted);
}
.lista { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; }
.item { display: flex; gap: var(--s-5); }
.riel { display: flex; flex-direction: column; align-items: center; width: 28px; flex: none; }
.icono {
  width: 28px; height: 28px; flex: none; border-radius: var(--r-full);
  display: flex; align-items: center; justify-content: center;
  background: var(--surface-sunken); color: var(--text-body);
}
.icono[data-tono="brand"] { background: var(--surface-brand-soft); color: var(--accent-700); }
.icono[data-tono="success"] { background: var(--status-success-bg); color: var(--text-success); }
.icono[data-tono="accent"] { background: var(--surface-accent-soft); color: var(--text-accent); }
.icono[data-tono="danger"] { background: var(--status-danger-bg); color: var(--text-danger); }
.icono[data-tono="warning"] { background: var(--status-warning-bg); color: var(--text-warning); }
.linea { width: 1px; flex: 1; min-height: 16px; background: var(--border-hair); }
.contenido { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; padding-bottom: var(--s-6); }
.encabezado { display: flex; justify-content: space-between; align-items: baseline; gap: var(--s-4); }
.texto { overflow-wrap: anywhere; line-height: 18px; }
